export const formatFileSize = (
  bytes: number,
  locale: string = 'en-US'
): string => {
  const units: string[] = ['B', 'kB', 'MB', 'GB'];
  let unitIndex: number = 0;

  while (bytes >= 1024 && unitIndex < units.length - 1) {
    bytes /= 1024;
    unitIndex++;
  }

  return `${bytes.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
  })} ${units[unitIndex]}`;
};
